import React from 'react';
import { Stack, StackProps } from '@hawkins/components';
import { Dimensions } from '@hawkins/variables';

export const HorizontalInputStack = ({ children, ...props }: StackProps) => {
  const childComponentCount = React.Children.toArray(children).filter((child) =>
    React.isValidElement(child)
  ).length;
  const gridTemplateColumns = `repeat(${childComponentCount}, 1fr)`;

  return (
    <Stack
      {...props}
      gap={Dimensions.Space16}
      orientation="horizontal"
      layout={{ gridTemplateColumns, ...props.layout }}
    >
      {children}
    </Stack>
  );
};
